module.exports = __webpack_public_path__ + "img/switch.d7e53240.svg";